import React from 'react';
import { Keyboard } from 'lucide-react';

/**
 * EmailShortcutsModal — keyboard shortcuts help dialog for the Email page.
 *
 * Pure presentational component (no state, no API). Extracted from
 * `pages/Email.jsx` (Wave 1u3 refactor step 2) to keep the main page lean.
 */
const SHORTCUTS = [
  ['c', 'Nouveau message'],
  ['j / k', 'Message suivant / précédent'],
  ['Entrée', 'Ouvrir le message sélectionné'],
  ['r', 'Répondre · ou Rafraîchir si aucun message ouvert'],
  ['a', 'Répondre à tous'],
  ['f', 'Transférer'],
  ['u', 'Marquer lu / non lu'],
  ['e', 'Archiver'],
  ['#', 'Mettre à la corbeille'],
  ['/', 'Recherche'],
  ['Esc', 'Fermer le message'],
  ['?', 'Afficher cette aide'],
];

export default function EmailShortcutsModal({ open, onClose }) {
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center p-4"
      onClick={onClose}
      data-testid="email-shortcuts-modal"
    >
      <div
        className="bg-white rounded-2xl shadow-2xl w-full max-w-md p-6"
        onClick={(e) => e.stopPropagation()}
      >
        <h3 className="text-[15px] font-bold text-[#1A1B2E] mb-3 flex items-center gap-2">
          <Keyboard className="w-4 h-4" /> Raccourcis clavier
        </h3>
        <ul className="text-[12.5px] space-y-1.5 text-[#4A4B63]">
          {SHORTCUTS.map(([keys, label]) => (
            <li key={keys} className="flex items-center justify-between">
              <span>{label}</span>
              <kbd className="px-2 py-0.5 text-[11px] font-mono bg-[#F6F7FB] border border-[#EFF0F6] rounded">{keys}</kbd>
            </li>
          ))}
        </ul>
        <div className="mt-4 pt-3 border-t border-[#EFF0F6] text-right">
          <button
            onClick={onClose}
            className="h-8 px-3 rounded-lg brand-gradient text-white text-[12px] font-semibold"
          >Fermer</button>
        </div>
      </div>
    </div>
  );
}
